import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles(() => ({
  root: {
    "& .MuiPaper-root": {
      maxWidth: "550px !important",
    },
  },
  content: {
    "&.MuiDialogContent-root": {
      paddingTop: "8px !important",
      paddingBottom: "12px !important",
    },
    "& > pre": {
      whiteSpace: "pre-line",
    },
  },
}));
